export const FAQData = [
  {
    q: "Cum adopt o rățușcă?",
    a: "Achiziționezi un bilet de participare online prin butonul „Adoptă o rățușcă” sau direct de la standurile noastre din Timișoara. Fiecare bilet îți dă numărul unei rățuște care va concura pentru tine.",
  },
  {
    q: "Cât costă un bilet?",
    a: "Un bilet (o rățușcă) costă 10 RON și reprezintă o donație integrală pentru cauza ediției 2026. Companiile pot alege un pachet de sponsorizare (Bronze, Silver, Gold, Platinum).",
  },
  {
    q: "Când și unde are loc cursa?",
    a: "Pe 1 iunie 2026, de Ziua Internațională a Copilului, în Timișoara. Cursa pornește de la Podul Mihai Viteazu și are linia de sosire la Podul Maria.",
  },
  {
    q: "Cine organizează evenimentul?",
    a: "Cursa de Rățuște pe Bega este organizată de clubul Rotaract Timișoara, cu sprijinul cluburilor Interact, Rotaract și Rotary din oraș.",
  },
  {
    q: "Ce premii pot câștiga?",
    a: "Persoanele care au biletele cu numerele rățuștelor care ajung primele la linia de sosire câștigă premiile oferite de partenerii noștri. Premiile se anunță în curând pe rețelele sociale.",
  },
  {
    q: "Ce se întâmplă cu fondurile strânse?",
    a: "În 2026, toți banii merg către dotarea Secției de Neonatologie a Spitalului Clinic de Urgență pentru Copii „Louis Țurcanu” din Timișoara — pătuțuri și aparate de monitorizare pentru nou-născuți.",
  },
  {
    q: "Trebuie să fiu prezent la cursă pentru a câștiga?",
    a: "Nu este obligatoriu, dar atmosfera de pe Bega merită din plin. Câștigătorii sunt anunțați la final și pe paginile noastre oficiale.",
  },
];
